<template>
  <svg
    fill="none"
    height="23"
    viewBox="0 0 23 23"
    width="23"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <g clip-path="url(#clip0_9401_79502)">
      <path
        d="M11.5 20.125C16.2635 20.125 20.125 16.2635 20.125 11.5C20.125 6.73654 16.2635 2.875 11.5 2.875C6.73654 2.875 2.875 6.73654 2.875 11.5C2.875 16.2635 6.73654 20.125 11.5 20.125Z"
        stroke="#696F79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.34375 12.9375V8.625L13.6562 6.46875V12.9375"
        stroke="#696F79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.0938 19.3434V13.6563C15.0938 13.4656 15.018 13.2828 14.8832 13.148C14.7484 13.0132 14.5656 12.9375 14.375 12.9375H8.625C8.43438 12.9375 8.25156 13.0132 8.11677 13.148C7.98198 13.2828 7.90625 13.4656 7.90625 13.6563V19.3434"
        stroke="#696F79"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9401_79502">
        <rect fill="white" height="23" width="23" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'GreyMarkerIcon23'
};
</script>

<style scoped>

</style>
